import React, { FC, useEffect, useRef, useState, ReactNode } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { PaginationProps, Tag } from 'antd'
import type { EventValue, RangeValue } from 'rc-picker/lib/interface'
import { Tabs, Table, Empty, Card, Space, Select, DatePicker, Row, Col } from 'antd'
import { BlockOutlined } from '@ant-design/icons'
import { IAppState } from '@/store/reducers'

// 引入 echarts 核心模块
import * as echarts from 'echarts/core'
import { LegendComponent, GridComponent, TooltipComponent, TitleComponent, DataZoomComponent,
    ToolboxComponent,
} from 'echarts/components'
import { CanvasRenderer } from 'echarts/renderers'
// 按需引入图表类型
import { BarChart, LineChart, PieChart } from 'echarts/charts'
import { barChart1Option } from '@/helpers/barChart'
import type { ILegendData } from '@/pages/charts'

import { useTranslation } from 'react-i18next'
import { getDicClass } from '@/pages/charts'
import { ifvisible } from '@/components/ifvisible.js/main'
import { getWorkgroup } from '@/store/actions/tableEdit.action'
import { getOnlineReview, expertReviewList, getCoreList, getCompleteTechList, monthlyProgressChart } from '@/services/progress.service'
import { getAllTechnicalAnalysis } from '@/services/table.service'
import { getErrorStr } from '@/store/sagas/table.saga'
import { requestFail } from '@/store/actions/common.action'
import type { Moment } from 'moment'
import moment from 'moment'
// import dayjs from 'dayjs'
// import quarterOfYear from 'dayjs/plugin/quarterOfYear'
import { cloneDeep } from 'lodash'
import { getUuid } from '@/utils/util'

// dayjs.extend(quarterOfYear)
echarts.use([
    BarChart, LineChart, PieChart, CanvasRenderer,
    LegendComponent, GridComponent, TooltipComponent, TitleComponent, DataZoomComponent,
    ToolboxComponent
])

interface childrenType {
    title: string
    dataIndex: string
    key: string
    editable?: boolean
    className?: string
    width?: number
    ellipsis: { showTitle: boolean },
    filters?: {
        text: string
        value: number
    }[]
    // eslint-disable-next-line no-unused-vars, @typescript-eslint/no-unused-vars
    onFilter?: (value: string, record: any) => boolean
    render?: any
}
interface IColProperty {
    title?: ReactNode | string
    className?: string
    editable?: boolean
    dataIndex?: string
    children?: childrenType[]
    filters?: {
        text: string
        value: string
    }[]
    // eslint-disable-next-line no-unused-vars, @typescript-eslint/no-unused-vars
    onFilter?: (value: string | number | boolean, record: any) => boolean
}
type EditableTableProps = Parameters<typeof Table>[0]
type ColumnTypes = Exclude<EditableTableProps['columns'], undefined>

const BigScreen2: FC = () => {
    const history = useHistory()
    const dispatch = useDispatch()
    const { t, i18n } = useTranslation()
    const { TabPane } = Tabs
    const { RangePicker } = DatePicker
    const dateFormat = 'YYYY'
    const dateFormat2 = 'YYYY[Q]Q'
    const momentObj = moment()

    const localCurTabBigScreen = localStorage.getItem('curTabBigScreen')
    const historyTabIndex = localCurTabBigScreen !== null ? localCurTabBigScreen : '1'
    const [curTab, setCurTab] = useState<string>('' + historyTabIndex)
    const localCurTabBigScreen2 = localStorage.getItem('curTabBigScreen2')
    const historyTabIndex2 = localCurTabBigScreen2 !== null ? localCurTabBigScreen2 : '1'
    const [curTab2, setCurTab2] = useState<string>('' + historyTabIndex2)
    const localCurTabBigScreen3 = localStorage.getItem('curTabBigScreen3')
    const historyTabIndex3 = localCurTabBigScreen3 !== null ? localCurTabBigScreen3 : '1'
    const [curTab3, setCurTab3] = useState<string>('' + historyTabIndex3)

    // eslint-disable-next-line no-unused-vars, @typescript-eslint/no-unused-vars
    const [winW, setWinW] = useState<number>(0)
    // eslint-disable-next-line no-unused-vars, @typescript-eslint/no-unused-vars
    const [winH, setWinH] = useState<number>(0)
    // 是否已获取过dicClassList
    const [gotDic, setGotDic] = useState(false)
    const [loaded, setLoaded] = useState(false)
    const [refreshUuid, setRefreshUuid] = useState('1')
    const [columns, setColumns] = useState<(ColumnTypes[number] & IColProperty)[][]>([])
    const [reviewLs, setReviewLs] = useState<any[]>([])
    const [reviewAll, setReviewAll] = useState<any[]>([])
    const [techType, setTechType] = useState<string>('DEVELOPING')
    const [dateRange, setDateRange] = useState<[EventValue<Moment>, EventValue<Moment>]>([moment().subtract(1, 'year'), momentObj])
    const [dateTechDevelop, setDateTechDevelop] = useState<EventValue<Moment>>(momentObj)
    // 近12个月完成开发的技术数量
    const [completeTechListDateRange, setCompleteTechListDateRange] = useState<[EventValue<Moment>, EventValue<Moment>]>([moment().subtract(1, 'year').add(1, 'quarter'), momentObj])
    const [tabData, setTabData] = useState<Record<string, any>>({})
    const [tabDataObj, setTabDataObj] = useState<{
        onlineReviewLs: any[]
        tableKey: string
        searchCont: any
        paginationInfo: {
            pageNo: number
            pageSize: number
            total: number
        }
    }[]>([{
        onlineReviewLs: [],
        tableKey: '1',
        searchCont: {},
        paginationInfo: {
            pageNo: 1,
            pageSize: 10,
            total: 0
        }
    }, {
        onlineReviewLs: [],
        tableKey: '2',
        searchCont: {},
        paginationInfo: {
            pageNo: 1,
            pageSize: 10,
            total: 0
        }
    }, {
        onlineReviewLs: [],
        tableKey: '3',
        searchCont: {},
        paginationInfo: {
            pageNo: 1,
            pageSize: 10,
            total: 0
        }
    },{
        onlineReviewLs: [],
        tableKey: '4',
        searchCont: {},
        paginationInfo: {
            pageNo: 1,
            pageSize: 10,
            total: 0
        }
    }
    ])
    
    const workgroupList = useSelector((state: IAppState) => state.tableEditData.workgroupList)
    const dicClassList = useSelector((state: IAppState) => state.tableEditData.dicClass)

    const chartRef1 = useRef<any>(null)
    const chartRef2 = useRef<any>(null)
    const chartRef3 = useRef<any>(null)
    const chartRef4 = useRef<any>(null)
    const chartRef5 = useRef<any>(null)
    const chartRef6 = useRef<any>(null)
    const chartInstance1 = useRef<any>(null)
    const chartInstance2 = useRef<any>(null)
    const chartInstance3 = useRef<any>(null)
    const chartInstance4 = useRef<any>(null)
    const chartInstance5 = useRef<any>(null)
    const chartInstance6 = useRef<any>(null)
    // 核心关键技术数量
    const coreTechList = useRef<any>(null)
    // pageSize 变更后，会重复触发 pageChange 事件
    const pageSizeChanged = useRef<boolean>(false)
    const approvalType = [
        { id: 1, label: t('technicalPlan') + (i18n.language !== 'zh' ? ' ' : '') + t('approval') },
        { id: 2, label: t('technicalDefineAndResearchTaskBook') + (i18n.language !== 'zh' ? ' ' : '') + t('approval') },
        { id: 3, label: t('technicalAchievementDelivery') + (i18n.language !== 'zh' ? ' ' : '') + t('approval') },
        { id: 4, label: t('buTMTApproveTech') + (i18n.language !== 'zh' ? ' ' : '') + t('approval') },
    ]
    const experterReviewTop = [
        { id: 1, label: t('curQuarter') },
        { id: 2, label: t('prevQuarter') },
    ]
    
    const allColumns: (ColumnTypes[number] & IColProperty)[] = [
        {
            title: () => <span>{t('proposalName')}</span>,
            dataIndex: 'proposalName',
            key: 'proposalName',
            ellipsis: { showTitle: true },
            className: 'col_auto',
            render (value: string, record: any) {
                if(Reflect.has(record, 'parent') && record.parent === null){
                    return <span style={{ display: 'block', wordBreak: 'break-all' }}>{value}</span>
                }else{
                    return (<><Tag color="error" style={{ marginRight: 4 }}>{t('secondReview')}</Tag><span>{value}</span></>)
                }
            }
        },
        {
            title: () => <span>{t('creator')}</span>,
            dataIndex: 'creator',
            key: 'creator',
            className: 'col_auto',
            width: 150,
            ellipsis: { showTitle: true },
        },
        {
            title: () => <span>{t('Work Group')}</span>,
            dataIndex: 'workGroup',
            key: 'workgroup',
            className: 'col_auto',
            width: 150,
            ellipsis: { showTitle: true },
            render (value: any) {
                return value.workGroupName
            }
        },
        {
            title: () => <span>{t('reviewMeeting') + (i18n.language !== 'zh' ? ' ' : '') + t('time')}</span>,
            dataIndex: 'reviewDate',
            key: 'reviewDate',
            className: 'col_auto',
            width: 150,
            ellipsis: { showTitle: true },
            render: (value: Date, record: any) => {
                return moment(value).format('YYYY-MM-DD') + (record.reviewDateHours ? ' ' + record.reviewDateHours : '')
            }
        },
    ]

    const columnsReviewTop: (ColumnTypes[number])[] = [
        {
            title: () => <span>{t('tmtUser')}</span>,
            dataIndex: 'tmtfulluser',
            key: 'tmtfulluser',
            ellipsis: { showTitle: true },
        },
        {
            title: () => <span>{`${t('join')}${i18n.language !== 'zh' ? ' ' : ''}(${t('multiple')})`}</span>,
            dataIndex: 'count',
            key: 'count',
            width: 120,
            ellipsis: { showTitle: true },
            render (value: number | undefined) {
                return value || 0
            }
        },
        // {
        //     title: () => <span>{`${t('join')}(${t('multiple')})`}</span>,
        //     dataIndex: 'isParticipate',
        //     key: 'isParticipate',
        //     width: 150,
        //     ellipsis: { showTitle: true },
        //     render (value: number | undefined) {
        //         return value || 0
        //     }
        // },
        // {
        //     title: () => <span>{`${t('abstention')}(${t('multiple')})`}</span>,
        //     dataIndex: 'abstention',
        //     key: 'abstention',
        //     width: 150,
        //     ellipsis: { showTitle: true },
        //     render (value: number | undefined) {
        //         return value || 0
        //     }
        // },
        // {
        //     title: () => <span>{`${t('notAddAbstention')}(${t('multiple')})`}</span>,
        //     dataIndex: 'noParticipate',
        //     key: 'noParticipate',
        //     width: 150,
        //     ellipsis: { showTitle: true },
        //     render (value: number | undefined) {
        //         return value || 0
        //     }
        // },
    ]

    const releaseIfVisibleEvent = (): void => {
        ifvisible.off('idle')
        ifvisible.off('wakeup')
        ifvisible.off('statusChanged')
    }

    const fullOption = (element: any, chartInstance: any, bottom = 250) => ({
        show: true,
        title: '全屏查看',
        right: 5,
        icon: 'path://M928 64H710.4c-14.933333 0-21.333333 17.066667-10.666667 27.733333l93.866667 93.866667-157.866667 157.866667c-12.8 12.8-12.8 32 0 44.8 6.4 6.4 14.933333 8.533333 23.466667 8.533333s17.066667-2.133333 23.466667-8.533333l157.866666-157.866667 93.866667 93.866667c10.666667 10.666667 27.733333 2.133333 27.733333-10.666667V96C960 78.933333 945.066667 64 928 64zM230.4 185.6l93.866667-93.866667c10.666667-10.666667 4.266667-27.733333-10.666667-27.733333H96C78.933333 64 64 78.933333 64 96v217.6c0 14.933333 17.066667 21.333333 27.733333 10.666667l93.866667-93.866667 157.866667 157.866667c6.4 6.4 14.933333 8.533333 23.466666 8.533333s17.066667-2.133333 23.466667-8.533333c12.8-12.8 12.8-32 0-44.8l-160-157.866667zM932.266667 699.733333l-93.866667 93.866667-157.866667-157.866667c-12.8-12.8-32-12.8-44.8 0s-12.8 32 0 44.8l157.866667 157.866667-93.866667 93.866667c-10.666667 10.666667-2.133333 27.733333 10.666667 27.733333h217.6c17.066667 0 32-14.933333 32-32V710.4c0-14.933333-17.066667-21.333333-27.733333-10.666667zM343.466667 635.733333l-157.866667 157.866667-93.866667-93.866667c-10.666667-10.666667-27.733333-4.266667-27.733333 10.666667v217.6c0 17.066667 14.933333 32 32 32h217.6c14.933333 0 21.333333-17.066667 10.666667-27.733333l-93.866667-93.866667 157.866667-157.866667c12.8-12.8 12.8-32 0-44.8s-32-12.8-44.8 0z',
        iconStyle: {
            color: '#036fc0',
            borderColor: '#036fc0'
        },
        onclick: () => {
            if (element.requestFullScreen) {
                element.requestFullScreen()
            } else if (element.msRequestFullscreen) {
                element.msRequestFullScreen()
            } else if (element.webkitRequestFullScreen) {
                element.webkitRequestFullScreen()
            } else if (element.mozRequestFullScreen) {
                element.mozRequestFullScreen()
            }
            const option = chartInstance.getOption()
            const newOption = {
                ...option,
                grid: {
                    ...option.grid,
                    bottom
                },
                xAxis: option.xAxis?.map((xAxi: any) => ({
                    ...xAxi,
                    axisLabel: {
                        ...xAxi.axisLabel,
                        fontSize: 20,
                        overflow: 'none'
                    }
                })),
                series: option.series?.map((serie: any) => ({
                    ...serie,
                    label: {
                        ...serie.label,
                        fontSize: 20,
                    }
                })),
                toolbox: {
                    ...option.toolbox[0],
                    feature: {
                        ...option.toolbox[0].feature,
                        myFull: {
                            ...option.toolbox[0].feature.myFull,
                            show: false
                        },
                        myExitFull: {
                            ...option.toolbox[0].feature.myExitFull,
                            show: true
                        }
                    }
                }
            }
            chartInstance.setOption(newOption)
            setTimeout(() => {
                chartInstance.resize()
            }, 100)
        },
    })
    const exitOption = (element: any, chartInstance: any, bottom = 90) => ({
        show: false,
        title: '退出全屏',
        icon: 'path://M320 128h64v256H128v-64h146.88l-169.6-169.28 45.44-45.44L320 274.88z m416 146.88V128h-64v256h256v-64h-146.88l169.6-169.28-45.44-45.44zM928 704v-64h-256v256h64v-146.88l169.28 169.6 45.44-45.44-169.6-169.28zM128 704h146.88l-169.6 169.28 45.44 45.44 169.28-169.6V896h64v-256H128z',
        iconStyle: {
            color: '#036fc0',
            borderColor: '#036fc0'
        },
        onclick: () => {
            // 退出全屏
            if (document.fullscreenElement) {
                document.exitFullscreen()
            }
            const option = chartInstance.getOption()
            const newOption = {
                ...option,
                grid: {
                    ...option.grid,
                    bottom
                },
                xAxis: option.xAxis?.map((xAxi: any) => ({
                    ...xAxi,
                    axisLabel: {
                        ...xAxi.axisLabel,
                        fontSize: 10,
                        overflow: 'truncate'
                    }
                })),
                series: option.series?.map((serie: any) => ({
                    ...serie,
                    label: {
                        ...serie.label,
                        fontSize: undefined,
                    }
                })),
                toolbox: {
                    ...option.toolbox[0],
                    feature: {
                        ...option.toolbox[0].feature,
                        myFull: {
                            ...option.toolbox[0].feature.myFull,
                            show: true
                        },
                        myExitFull: {
                            ...option.toolbox[0].feature.myExitFull,
                            show: false
                        }
                    }
                }
            }
            chartInstance.setOption(newOption)
            setTimeout(() => {
                chartInstance.resize()
                const childs = element.childNodes
                childs[childs.length - 1].style.display = 'none'
            }, 100)
        }
    })

    const goIndex = () => {
        history.push('/indexPage')
    }

    const setChart1 = async (data: {
        [property: string]: number
    }[]) => {
        const chart = chartRef1.current
        console.log('chartRef1: ', chart)
        if (chart) {
            let chartInstance = chartInstance1.current
            console.log('chartInstance: ', chartInstance)
            if (!chartInstance) {
                chartInstance1.current = echarts.init(chart)
                chartInstance = chartInstance1.current
            } else {
                chartInstance.clear()
            }
            
            const xAxis: string[] = data.map(item => Object.keys(item)[0])
            const series: ILegendData[] = [{
                type: 'bar',
                name: 'count',
                data: data.map(item => Object.values(item)[0]),
                barMaxWidth: 60,
                barMinHeight: 5,
                label: {
                    show: true
                }
            }]
            const option = cloneDeep(barChart1Option)
            option.legend.data = []
            option.xAxis.data = xAxis
            option.series = series
            const newOption = {
                ...option,
                grid: {
                    ...option.grid,
                    left: 50,
                    right: 10,
                    top: 30,
                    bottom: 90
                },
                title: {
                    show: false
                },
                legend: {
                    ...option.legend,
                    bottom: 10,
                    textStyle: {
                        color: '#333'
                    }
                },
                xAxis: {
                    ...option.xAxis,
                    axisLabel: {
                        ...option.xAxis.axisLabel,
                        fontSize: 10,
                        rotate: 45,
                        width: 150,
                        color: '#333'
                    }
                },
                yAxis: {
                    ...option.yAxis,
                    splitNumber: 4,
                    axisLabel: {
                        color: '#333'
                    }
                },
                toolbox: {
                    feature: {
                        // 全屏具体实现
                        myFull: fullOption(chartRef1.current, chartInstance1.current),
                        myExitFull: exitOption(chartRef1.current, chartInstance1.current)
                    },
                }
            }
            chartInstance.setOption(newOption)
        }
    }
    const setChart2 = async (data: {
        [property: string]: number
    }[]) => {
        const chart = chartRef2.current
        if (chart) {
            let chartInstance = chartInstance2.current
            if (!chartInstance) {
                chartInstance2.current = echarts.init(chart)
                chartInstance = chartInstance2.current
            } else {
                chartInstance.clear()
            }
            
            const xAxis: string[] = data.map(item => Object.keys(item)[0])
            const series: ILegendData[] = [{
                type: 'bar',
                name: 'count',
                data: data.map(item => Object.values(item)[0]),
                barMaxWidth: 60,
                barMinHeight: 5,
                label: {
                    show: true
                }
            }]
            const option = cloneDeep(barChart1Option)
            option.legend.data = []
            option.xAxis.data = xAxis
            option.series = series
            chartInstance.setOption({
                ...option,
                grid: {
                    ...option.grid,
                    left: 50,
                    right: 10,
                    top: 30,
                    bottom: 90
                },
                title: {
                    show: false
                },
                legend: {
                    ...option.legend,
                    bottom: 10,
                    textStyle: {
                        color: '#333'
                    }
                },
                xAxis: {
                    ...option.xAxis,
                    axisLabel: {
                        ...option.xAxis.axisLabel,
                        fontSize: 10,
                        rotate: 45,
                        width: 150,
                        color: '#333'
                    }
                },
                yAxis: {
                    ...option.yAxis,
                    splitNumber: 4,
                    axisLabel: {
                        color: '#333'
                    }
                },
                toolbox: {
                    feature: {
                        // 全屏具体实现
                        myFull: fullOption(chartRef2.current, chartInstance2.current),
                        myExitFull: exitOption(chartRef2.current, chartInstance2.current)
                    },
                }
            })
        }
    }
    const setChart3 = async (data: any[], year = momentObj.year()) => {
        const chart = chartRef3.current
        if (chart) {
            let chartInstance = chartInstance3.current
            if (!chartInstance) {
                chartInstance3.current = echarts.init(chart)
                chartInstance = chartInstance3.current
            } else {
                chartInstance.clear()
            }
            const passArr: number[] = []
            const noPassArr: number[] = []
            const passReduceArr: number[] = []
            const noPassReduceArr: number[] = []
            // 12个月补零
            let monthPassCount = 0, monthNoPassCount = 0
            for (let i = 1; i <= 12; i++) {
                const yearMonth = year + '-' + (i < 10 ? ('0' + i) : i )
                const findArr = data.filter(item => item.yearMonth === yearMonth)
                if (findArr.length > 0) {
                    let passCount = 0, noPassCount = 0
                    let findObj = findArr.shift()
                    while(findObj) {
                        if (findObj.isPassed) {
                            passCount += findObj.count
                            monthPassCount += findObj.count
                        } else {
                            noPassCount += findObj.count
                            monthNoPassCount += findObj.count
                        }
                        findObj = findArr.shift()
                    }
                    passArr.push(passCount)
                    passReduceArr.push(monthPassCount)
                    noPassArr.push(noPassCount)
                    noPassReduceArr.push(monthNoPassCount)
                } else {
                    passArr.push(0)
                    passReduceArr.push(passReduceArr.length === 0 ? 0 : passReduceArr[passReduceArr.length - 1])
                    noPassArr.push(0)
                    noPassReduceArr.push(noPassReduceArr.length === 0 ? 0 : noPassReduceArr[noPassReduceArr.length - 1])
                }
            }
            const xAxis: string[] = [t('jan'), t('feb'), t('mar'), t('apr'), t('may'), t('jun'), t('jul'), t('aug'), t('sep'), t('oct'), t('nov'), t('dec')]
            const series: ILegendData[] = [{
                type: 'bar',
                name: t('reviewResultTrue'),
                stack: 'isPassed',
                data: passArr,
                barMaxWidth: 60,
                label: {
                    show: true
                }
            }, {
                type: 'bar',
                name: t('reviewResultFalse'),
                stack: 'isPassed',
                data: noPassArr,
                barMaxWidth: 60,
                label: {
                    show: true
                }
            }, {
                type: 'line',
                name: t('accumulate') + (i18n.language !== 'zh' ? ' ' : '') + t('reviewResultTrue'),
                data: passReduceArr,
                smooth: true,
                label: {
                    show: true,
                    textBorderColor: 'transparent'
                }
            }, {
                type: 'line',
                name: t('accumulate') + (i18n.language !== 'zh' ? ' ' : '') + t('reviewResultFalse'),
                data: noPassReduceArr,
                smooth: true,
                label: {
                    show: true,
                    textBorderColor: 'transparent'
                }
            }]
            const option = cloneDeep(barChart1Option)
            option.legend.data = [t('reviewResultTrue'), t('reviewResultFalse'),
                t('accumulate') + (i18n.language !== 'zh' ? ' ' : '') + t('reviewResultTrue'),
                t('accumulate') + (i18n.language !== 'zh' ? ' ' : '') + t('reviewResultFalse')
            ]
            option.xAxis.data = xAxis
            option.series = series
            chartInstance.setOption({
                ...option,
                grid: {
                    ...option.grid,
                    left: 40,
                    top: 30,
                    bottom: 55
                },
                color: ['#91cc75', '#ef6b6b', '#5aa835', '#fac858'],
                title: {
                    show: false
                },
                legend: {
                    ...option.legend,
                    bottom: 0,
                    textStyle: {
                        color: '#333'
                    }
                },
                xAxis: {
                    ...option.xAxis,
                    axisLabel: {
                        ...option.xAxis.axisLabel,
                        fontSize: 9,
                        rotate: 45,
                        width: 150,
                        color: '#333'
                    }
                },
                yAxis: {
                    ...option.yAxis,
                    splitNumber: 4,
                    axisLabel: {
                        color: '#333'
                    }
                },
                toolbox: {
                    feature: {
                        // 全屏具体实现
                        myFull: fullOption(chartRef3.current, chartInstance3.current, 100),
                        myExitFull: exitOption(chartRef3.current, chartInstance3.current, 55)
                    },
                }
            })
        }
    }
    const setChart4 = async (data: any[]) => {
        const chart = chartRef4.current
        if (chart) {
            let chartInstance = chartInstance4.current
            if (!chartInstance) {
                chartInstance4.current = echarts.init(chart)
                chartInstance = chartInstance4.current
            } else {
                chartInstance.clear()
            }
            chartInstance.setOption({
                title: {
                    text: t('costRatio'),
                    x: 'center',
                    bottom: 0,
                    textStyle: {
                        fontSize: 15,
                        fontWeight: 'normal'
                    }
                },
                tooltip: {
                    trigger: 'item',
                    formatter: '{b} : {c} ({d}%)'
                },
                legend: {
                    show: false
                },
                toolbox: {
                    feature: {
                        // 全屏具体实现
                        myFull: fullOption(chartRef4.current, chartInstance4.current),
                        myExitFull: exitOption(chartRef4.current, chartInstance4.current)
                    },
                },
                series: [
                    {
                        name: 'workgroup',
                        type: 'pie',
                        radius: '55%',
                        center: ['50%', '50%'],
                        minShowLabelAngle: 10,
                        data: data.map(item => ({ value: item.num, name: item.techClass.workGroup.workGroupName })),
                        label: {
                            formatter: '{b} : {c}\n ({d}%)'
                        },
                        emphasis: {
                            itemStyle: {
                                shadowBlur: 10,
                                shadowOffsetX: 0,
                                shadowColor: 'rgba(0, 0, 0, 0.5)'
                            }
                        }
                    }
                ]
            })
        }
    }
    const setChart5 = async (data: any[]) => {
        const chart = chartRef5.current
        if (chart) {
            let chartInstance = chartInstance5.current
            if (!chartInstance) {
                chartInstance5.current = echarts.init(chart)
                chartInstance = chartInstance5.current
            } else {
                chartInstance.clear()
            }
            chartInstance.setOption({
                title: {
                    text: t('productClassRatio'),
                    x: 'center',
                    bottom: 0,
                    textStyle: {
                        fontSize: 15,
                        fontWeight: 'normal'
                    }
                },
                tooltip: {
                    trigger: 'item',
                    formatter: '{b} : {c} ({d}%)'
                },
                legend: {
                    show: false
                },
                toolbox: {
                    feature: {
                        // 全屏具体实现
                        myFull: fullOption(chartRef5.current, chartInstance5.current),
                        myExitFull: exitOption(chartRef5.current, chartInstance5.current)
                    },
                },
                series: [
                    {
                        name: 'bu',
                        type: 'pie',
                        radius: '65%',
                        center: ['50%', '50%'],
                        minShowLabelAngle: 10,
                        data: data.map(item => ({ value: item.num, name: item.platform })),
                        avoidLabelOverlap: false,
                        label: {
                            formatter: '{b} : {c}\n ({d}%)'
                        },
                        emphasis: {
                            itemStyle: {
                                shadowBlur: 10,
                                shadowOffsetX: 0,
                                shadowColor: 'rgba(0, 0, 0, 0.5)'
                            }
                        }
                    }
                ]
            })
        }
    }
    const setChart6 = async (data: any[]) => {
        const chart = chartRef6.current
        if (chart) {
            let chartInstance = chartInstance6.current
            if (!chartInstance) {
                chartInstance6.current = echarts.init(chart)
                chartInstance = chartInstance6.current
            } else {
                chartInstance.clear()
            }
            chartInstance.setOption({
                title: {
                    text: t('buRatio'),
                    x: 'center',
                    bottom: 0,
                    textStyle: {
                        fontSize: 15,
                        fontWeight: 'normal'
                    }
                },
                tooltip: {
                    trigger: 'item',
                    formatter: '{b} : {c} ({d}%)'
                },
                legend: {
                    show: false
                },
                toolbox: {
                    feature: {
                        // 全屏具体实现
                        myFull: fullOption(chartRef6.current, chartInstance6.current),
                        myExitFull: exitOption(chartRef6.current, chartInstance6.current)
                    },
                },
                series: [
                    {
                        name: 'bu',
                        type: 'pie',
                        radius: '65%',
                        center: ['50%', '50%'],
                        minShowLabelAngle: 10,
                        data: data.map(item => ({ value: item.num, name: item.bu })),
                        label: {
                            formatter: '{b} : {c}\n ({d}%)'
                        },
                        emphasis: {
                            itemStyle: {
                                shadowBlur: 10,
                                shadowOffsetX: 0,
                                shadowColor: 'rgba(0, 0, 0, 0.5)'
                            }
                        }
                    }
                ]
            })
        }
    }

    // 评审中的提案
    const onChangeTabs = (activeKey: string) => {
        setCurTab(activeKey)
        localStorage.setItem('curTabBigScreen', activeKey)
    }
    // TMT专家评审榜单
    const onChangeTabs2 = (activeKey: string) => {
        setCurTab2(activeKey)
        localStorage.setItem('curTabBigScreen2', activeKey)
    }
    // 技术评审月度推移图 切换 tabs
    const onChangeTabs3 = (activeKey: string) => {
        setCurTab3(activeKey)
        monthlyProgressChartFn({
            reviewType: Number(activeKey),
            year: dateTechDevelop?.year() || momentObj.year()
        })
    }
    // 分页
    // eslint-disable-next-line no-unused-vars, @typescript-eslint/no-unused-vars
    const onPaginationChange: PaginationProps['onChange'] = (pageNumber: number): void => {
        if (pageSizeChanged.current) return
        const arr = [...tabDataObj]
        const index = Number(curTab) - 1
        arr[index].paginationInfo = {
            ...arr[index].paginationInfo,
            pageNo: pageNumber
        }
        setTabDataObj([...arr])
        setRefreshUuid(getUuid(8))
    }
    // eslint-disable-next-line no-unused-vars, @typescript-eslint/no-unused-vars
    const onPageSizeChange = (current: number, size: number) => {
        // 避免重复触发 pageChange 事件
        pageSizeChanged.current = true
        const arr = [...tabDataObj]
        arr[parseInt(curTab)  - 1].paginationInfo = {
            ...arr[parseInt(curTab) - 1].paginationInfo,
            pageNo: 1,
            pageSize: size
        }
        setTabDataObj([...arr])
        setRefreshUuid(getUuid(8))
        setTimeout(() => {
            pageSizeChanged.current = false
        }, 100)
    }

    // 核心关键技术 根据分类获取列表
    const getCoreListByType = (type: string) => {
        let arr: any[] = []
        if (type === 'total') {
            const obj: any = {};
            ['DEVELOPING', 'RELEASED', 'PLANNING'].forEach((key: string) => {
                const item = coreTechList.current[key]
                Object.keys(item).forEach(itemKey => {
                    if (!Reflect.has(obj, itemKey)) {
                        obj[itemKey] = item[itemKey]
                    } else {
                        obj[itemKey] += item[itemKey]
                    }
                })
            })
            arr = Object.keys(obj).map(key => ({
                [key]: obj[key]
            }))
        } else {
            Object.keys(coreTechList.current[type]).forEach(key => {
                const obj: Record<string, any> = {}
                obj[key] = coreTechList.current[type][key]
                arr.push(obj)
            })
        }
        workgroupList.forEach(workgroup => {
            const findObj = arr.find(item => Object.keys(item)[0] === workgroup.groupName)
            if (!findObj) {
                arr.push({
                    [workgroup.groupName]: 0
                })
            }
        })
        const chartData = arr.sort((a, b) => b[Object.keys(b)[0]] - a[Object.keys(a)[0]])
        if (chartData.length > 0) {
            setChart1(chartData)
        }
    }
    // 切换核心关键技术分类
    const handleChangeCoreTech = (val: string) => {
        setTechType(val)
        // 核心关键技术 根据分类获取列表
        getCoreListByType(val)
    }
    // 切换核心关键技术 日期区间
    const onChangeDate = (dates: RangeValue<Moment>) => {
        if (dates) {
            setDateRange(dates)
            // 获取 核心关键技术数量
            getCoreListFn({
                startYear: (dates[0] as Moment).year(),
                endYear: (dates[1] as Moment).year()
            })
        } else {
            setDateRange([null, null])
        }
    }

    // 近12个月完成开发的技术数量 选择季度区间
    const onChangeDateCompleteTechList = (dates: RangeValue<Moment>) => {
        console.log('dates: ', dates)
        if (dates) {
            setCompleteTechListDateRange(dates)
            getCompleteTechListFn({
                startYearQuarter: (dates[0] as Moment).format('YYYY0Q'),
                endYearQuarter: (dates[1] as Moment).format('YYYY0Q'),
            })
        } else {
            setCompleteTechListDateRange([null, null])
            setChart2([])
        }
    }

    // 技术评审月度推移图 选择年
    const onChangeYearMonthDevelop = (date: Moment | null) => {
        console.log('date: ', date)
        setDateTechDevelop(date)
        monthlyProgressChartFn({
            reviewType: Number(curTab3),
            year: date?.year() || momentObj.year()
        })
    }

    // 获取评审中的提案列表
    const getLs = async () => {
        try {
            const index = Number(curTab) - 1

            setLoaded(false)
            const arr = [...tabDataObj]
            const res = await getOnlineReview({
                ...arr[index].searchCont,
                ...arr[index].paginationInfo,
                total: undefined,
                reviewType: Number(curTab),
                reviewProcess: 'ongoing'
            })
            setLoaded(true)
            
            arr[index].paginationInfo = {
                ...arr[index].paginationInfo,
                total: res.totalElements
            }
            arr[index].tableKey = getUuid(8)
            arr[index].onlineReviewLs = res.content
            setTabDataObj([...arr])
            setTabData({
                ...tabData,
                [`tab${curTab}`]: true
            })
        } catch (error: any) {
            const str = getErrorStr(error)
            dispatch(requestFail(str))
        }
    }

    // 获取TMT专家评审榜单
    const getReviewLs = async () => {
        const data = await expertReviewList()
        data.forEach((item: any) => {
            item.key = item.tmtfulluser + '_' + item.reviewYear + '_' + item.yearQuarter
        })
        setReviewAll(data)
    }

    // 获取核心关键技术数量
    const getCoreListFn = async ({ startYear, endYear }: {
        startYear: number
        endYear: number
    }) => {
        const res = await getCoreList({
            startYear,
            endYear
        })
        coreTechList.current = res
        // 核心关键技术 根据分类获取列表
        getCoreListByType(techType)
    }

    // 获取近12个月完成开发的技术数量
    const getCompleteTechListFn = async ({ startYearQuarter, endYearQuarter }: {
        startYearQuarter: string
        endYearQuarter: string
    }) => {
        const res = await getCompleteTechList({
            startYearQuarter,
            endYearQuarter,
        })
        const arr: {
            [property: string]: number
        }[] = []
        Object.keys(res).forEach(key => {
            arr.push({
                [key]: res[key]
            })
        })
        workgroupList.forEach(workgroup => {
            const findObj = arr.find(item => Object.keys(item)[0] === workgroup.groupName)
            if (!findObj) {
                arr.push({
                    [workgroup.groupName]: 0
                })
            }
        })
        setChart2(arr.sort((a, b) => Object.values(b)[0] - Object.values(a)[0]))
    }

    // 技术评审月度推移图
    // eslint-disable-next-line no-unused-vars, @typescript-eslint/no-unused-vars
    const monthlyProgressChartFn = async ({ reviewType, year }: {
        reviewType: number
        year: number
    }) => {
        const res = await monthlyProgressChart({
            year
        })
        setChart3(res, year)
    }

    // 获取 价值分析 数据
    const getAllTechnicalAnalysisFn = async () => {
        const res = await getAllTechnicalAnalysis(null)
        // 按技术域分类
        const techClassObj: Record<string, any> = {}
        // 按产品系列分类
        const platformObj: Record<string, any> = {}
        // 按bu分类
        const buObj: Record<string, any> = {}
        res.forEach(item => {
            if (!Reflect.has(techClassObj, item.techClass.workGroup.id)) {
                techClassObj[item.techClass.workGroup.id] = {
                    ...item,
                    num: 1
                }
            } else {
                techClassObj[item.techClass.workGroup.id].num++
            }
            // 因platforms是数组，有的item会统计到多个系列，总数会比数据超出
            item.platforms.forEach(subItem => {
                if (!Reflect.has(platformObj, subItem.platform)) {
                    platformObj[subItem.platform] = {
                        ...item,
                        platform: subItem.platform,
                        num: 1
                    }
                } else {
                    platformObj[subItem.platform].num++
                }
            })
            item.relevanceBuss?.forEach(subItem => {
                if (!Reflect.has(buObj, subItem.bu)) {
                    buObj[subItem.bu] = {
                        ...item,
                        bu: subItem.bu,
                        num: 1
                    }
                } else {
                    buObj[subItem.bu].num++
                }
            })
        })
        const techClassArr: any[] = Object.keys(techClassObj).map(key => techClassObj[key])
        const platformArr: any[] = Object.keys(platformObj).map(key => platformObj[key])
        const buArr: any[] = Object.keys(buObj).map(key => buObj[key])
        console.log('按技术域分类: ', techClassArr, techClassArr.map(item => item.num))
        console.log('按产品系列分类: ', platformArr, platformArr.map(item => item.platform), platformArr.map(item => item.num))
        console.log('按bu分类: ', buArr, buArr.map(item => item.bu), buArr.map(item => item.num))
        setChart4(techClassArr)
        setChart5(platformArr)
        setChart6(buArr)
    }

    const setTableColumn = () => {
        const columnArr = cloneDeep(allColumns).filter((c: any) => {
            if (c.key === 'isDisruptive' || c.key === 'disruptiveReview' || c.key === 'isCross' || c.key === 'isCrossReview') {
                return curTab === '1'
            } else {
                return true
            }
        })
        const countW = columnArr.reduce((prev: number, curr: any) => {
            return prev + (curr.width || 0)
        }, 0)
        columnArr[0].width = Math.max((winW || document.body.clientWidth) * .58 - countW - 80, 100)
        
        const columnsTemp = [...columns]
        // switch(curTab) {
        //     case '1':
        //         columnsTemp[0] = columnArr
        //         break
        //     case '2':
        //         columnsTemp[1] = columnArr
        //         break
        //     case '3':
        //         columnsTemp[2] = columnArr
        //         break
        // }
        columnsTemp[Number(curTab) - 1] = columnArr
        setColumns(columnsTemp)
    }

    useEffect(() => {
        // 避免已获取过后，还是无数据的情况
        if (!gotDic && Object.keys(dicClassList).length === 0) {
            getDicClass(dispatch, setGotDic)
        } else {
            setGotDic(true)
        }

        // TMT专家评审榜单
        getReviewLs()

        // 核心关键技术数量
        getCoreListFn({
            startYear: (dateRange[0] as Moment).year(),
            endYear: (dateRange[1] as Moment).year(),
        })

        // 近12个月完成开发的技术数量
        getCompleteTechListFn({
            startYearQuarter: (completeTechListDateRange[0] as Moment).format('YYYY0Q'),
            endYearQuarter: (completeTechListDateRange[1] as Moment).format('YYYY0Q'),
        })

        // 技术评审月度推移图
        monthlyProgressChartFn({
            reviewType: Number(curTab3),
            year: dateTechDevelop?.year() || momentObj.year()
        })

        // 获取 价值分析
        getAllTechnicalAnalysisFn()

        setTimeout(releaseIfVisibleEvent, 1000)

        if (workgroupList.length === 0) {
            // 获取 workgroupList
            dispatch(getWorkgroup())
        }

        const h = 130
        setWinW(document.body.clientWidth)
        setWinH(document.body.clientHeight - h)
        window.onresize = () => {
            setWinW(document.body.clientWidth)
            setWinH(document.body.clientHeight - h)
        }
        return () => {
            window.onresize = null
        }
    }, [])
    useEffect(() => {
        if (gotDic && workgroupList.length > 0) {
            console.log('gotDic: ', gotDic, workgroupList)
        }
    }, [gotDic, workgroupList])
    // 分页和切换 页显示数 的事件剔重
    useEffect(() => {
        if (refreshUuid !== '1') {
            getLs()
        }
    }, [refreshUuid])
    // 评审中的提案
    useEffect(() => {
        if (!tabData[`tab${curTab}`]) {
            setTableColumn()
            getLs()
        }
    }, [curTab])
    useEffect(() => {
        if (winH) {
            setTableColumn()
        }
    }, [winW])
    // TMT专家评审榜单
    useEffect(() => {
        const curQuarter = moment().quarter()
        // 根据 tab 值，过滤出 年季度 数据
        const arr = reviewAll.filter(item => item.reviewYear === new Date().getFullYear() &&
            (Number(curTab2) === 1 ? item.yearQuarter === curQuarter : item.yearQuarter === curQuarter - 1))
        const groupByUser = arr.reduce((group: any, currItem: any) => {
            const { tmtfulluser } = currItem
            if (!group[tmtfulluser]) {
                // if (currItem.participate) {
                //     currItem.participateTrue = currItem.count
                // } else if (currItem.participate === false) {
                //     currItem.participateFalse = currItem.count
                // } else {
                //     currItem.participateNull = currItem.count
                // }
                group[tmtfulluser] = currItem
                group[tmtfulluser].count = 0
            } else {
                // if (currItem.participate) {
                //     group[tmtfulluser].participateTrue = currItem.count
                // } else if (currItem.participate === false) {
                //     group[tmtfulluser].participateFalse = currItem.count
                // } else {
                //     group[tmtfulluser].participateNull = currItem.count
                // }
            }
            group[tmtfulluser].count += currItem.isParticipate + currItem.abstention + currItem.noParticipate
            return group
        }, {})
        console.log('groupByUser: ', groupByUser)
        const result = Object.values(groupByUser).sort((a: any, b: any) => b.count - a.count).slice(0, 10)
        setReviewLs(result)
    }, [curTab2, reviewAll])
    // 核心关键技术数量图表
    useEffect(() => {
        console.log('winH: ', winH)
        if (chartInstance1.current) {
            chartInstance1.current.resize()
        }
        if (chartInstance2.current) {
            chartInstance2.current.resize()
        }
        if (chartInstance3.current) {
            chartInstance3.current.resize()
        }
        if (chartInstance4.current) {
            chartInstance4.current.resize()
        }
        if (chartInstance5.current) {
            chartInstance5.current.resize()
        }
        if (chartInstance6.current) {
            chartInstance6.current.resize()
        }
    }, [winH])

    return (
        <div className="big_screen3">
            <h1 style={{ padding: '10px 0', textAlign: 'center', cursor: 'pointer' }} onClick={goIndex}>{t('bigScreenTitle')}</h1>
            <Row gutter={10}>
                <Col span={10} lg={{ span: 6 }}>
                    <Card size="small"
                        style={{ height: 'calc(100% - 10px)' }}
                        title={`${new Date().getFullYear()}${t('year')} ${t('techCostInfo')}(${t('developing')})`}
                    >
                        <div ref={chartRef4} style={{ width: '100%', height: Math.max(winH / 3 - 10, 300), backgroundColor: '#fff' }} />
                        <div ref={chartRef5} style={{ width: '100%', height: Math.max(winH / 3 - 10, 300), backgroundColor: '#fff' }} />
                        <div ref={chartRef6} style={{ width: '100%', height: Math.max(winH / 3 - 10, 300), backgroundColor: '#fff' }} />
                    </Card>
                </Col>
                <Col span={14} lg={{ span: 18 }}>
                    <Row gutter={10}>
                        <Col span={14} style={{ marginBottom: 10 }}>
                            <Card size="small"
                                style={{ marginBottom: 10 }}
                                title={<span title={`${t('coreTechnologyCount')}`}>
                                    {t('coreTechnologyCount')}
                                </span>}
                                extra={<div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                    <RangePicker
                                        style={{ width: 180 }}
                                        picker="year"
                                        format={dateFormat}
                                        value={dateRange}
                                        onChange={onChangeDate}
                                    />
                                    <Select
                                        value={techType}
                                        style={{ marginLeft: 20, marginRight: 20, width: 100 }}
                                        onChange={handleChangeCoreTech}
                                        options={[
                                            { value: 'total', label: t('plannedTotal') },
                                            { value: 'DEVELOPING', label: t('developing') },
                                            { value: 'RELEASED', label: t('delivered') },
                                            { value: 'PLANNING', label: t('planning') },
                                        ]}
                                    />
                                </div>}
                            >
                                <div ref={chartRef1} style={{ width: '100%', height: Math.max(winH / 2 - 375, 230), backgroundColor: '#fff'  }} />
                            </Card>
                            <Card size="small" title={t('last12MonthTechCount')}
                                extra={<RangePicker
                                    style={{ marginLeft: 20, width: 180 }}
                                    picker="quarter"
                                    format={dateFormat2}
                                    value={completeTechListDateRange}
                                    onChange={onChangeDateCompleteTechList}
                                />}
                            >
                                <div ref={chartRef2} style={{ width: '100%', height: Math.max(winH / 2 - 386, 219), backgroundColor: '#fff' }} />
                            </Card>
                        </Col>
                        <Col span={10} style={{ marginBottom: 10 }}>
                            <Card size="small"
                                style={{ marginBottom: 10 }}
                                title={`${new Date().getFullYear()}${t('year')} ${t('tmtReviewTop')}`}
                            >
                                <Tabs className='tabs_head_mb'
                                    type="card"
                                    size="small"
                                    defaultActiveKey={curTab2}
                                    tabPosition="top"
                                    onChange={onChangeTabs2}
                                >
                                    {experterReviewTop.map((_, i) => <TabPane tab={experterReviewTop[i].label} key={experterReviewTop[i].id}>
                                        <Table bordered
                                            key="tmtfulluser"
                                            size="small"
                                            columns={columnsReviewTop}
                                            dataSource={reviewLs}
                                            scroll={{ y: Math.max(winH / 2 - 400, 204) - 39 }}
                                            style={{ height: Math.max(winH / 2 - 400, 204) }}
                                            pagination={false}
                                        >
                                        </Table>
                                    </TabPane>)}
                                </Tabs>
                            </Card>
                            <Card size="small"
                                title={t('techMonthDevelopChart')}
                                extra={<DatePicker picker="year"
                                    style={{ marginLeft: 20, width: 100 }}
                                    value={dateTechDevelop}
                                    onChange={onChangeYearMonthDevelop}
                                />}
                            >
                                <div ref={chartRef3} style={{ width: '100%', height: Math.max(winH / 2 - 385, 219), backgroundColor: '#fff' }}></div>
                            </Card>
                        </Col>
                    </Row>
                    <Card size="small"
                        style={{ marginBottom: 10 }}
                        title={t('reviewingProposal')}
                    >
                        <Tabs className='tabs_head_mb'
                            type="card"
                            size="small"
                            defaultActiveKey={curTab}
                            tabPosition="top"
                            onChange={onChangeTabs}
                        >
                            {approvalType.map((_, i) => <TabPane tab={approvalType[i].label} key={approvalType[i].id}>
                                {tabDataObj.length > i ? <Table bordered
                                    size="small"
                                    key={tabDataObj[i].tableKey}
                                    dataSource={tabDataObj[i].onlineReviewLs}
                                    loading={curTab === String(i + 1) ? !loaded : false}
                                    columns={columns[Number(curTab) - 1]}
                                    defaultExpandAllRows={true}
                                    rowKey="id"
                                    scroll={{ x: 'max-content', y: Math.max(winH / 2 - 450, 300) - 39 }}
                                    style={{ height: Math.max(winH / 2 - 450, 300) }}
                                    pagination={false}
                                /> : <Empty />}
                            </TabPane>)}
                        </Tabs>
                    </Card>
                </Col>
            </Row>
            {!1 && <Space direction='vertical' style={{ position: 'relative', top: -15 }}>
                <Card title={<><BlockOutlined /> {t('reviewingProposal')}</>}>
                    {!1 && <Tabs className='tabs_head_mb'
                        type="card"
                        defaultActiveKey={curTab}
                        tabPosition="top"
                        onChange={onChangeTabs}
                    >
                        {approvalType.map((_, i) => <TabPane tab={approvalType[i].label} key={approvalType[i].id}>
                            {tabDataObj.length > i ? <Table bordered
                                key={tabDataObj[i].tableKey}
                                dataSource={tabDataObj[i].onlineReviewLs}
                                loading={curTab === String(i + 1) ? !loaded : false}
                                columns={columns[Number(curTab) - 1]}
                                defaultExpandAllRows={true}
                                rowKey="id"
                                scroll={{ x: 'max-content' }}
                                pagination={false}
                                // pagination={{
                                //     current: tabDataObj[i].paginationInfo.pageNo,
                                //     pageSize: tabDataObj[i].paginationInfo.pageSize,
                                //     total: tabDataObj[i].paginationInfo.total,
                                //     showQuickJumper: true,
                                //     onChange: onPaginationChange,
                                //     showSizeChanger: true,
                                //     onShowSizeChange: onPageSizeChange,
                                //     showTotal: (total) => 
                                //         `${t('total')} ${total} ${t('items')}`
                                // }}
                            /> : <Empty />}
                        </TabPane>)}
                    </Tabs>}
                </Card>
                {!1 && <Card title={<><BlockOutlined /> {t('tmtReviewTop')}</>}>
                    <Tabs className='tabs_head_mb'
                        type="card"
                        defaultActiveKey={curTab2}
                        tabPosition="top"
                        onChange={onChangeTabs2}
                    >
                        {experterReviewTop.map((_, i) => <TabPane tab={experterReviewTop[i].label} key={experterReviewTop[i].id}>
                            {/* <List
                                bordered
                                dataSource={reviewLs}
                                renderItem={(item) => (
                                    <List.Item>
                                        {item.tmtfulluser} {t('allNum')}: {item.count}
                                        <Typography.Text mark>[{
                                            item.participate ? t('join') : (item.participate === false ? t('abstention') : t('notAddAbstention'))
                                        }]</Typography.Text>
                                    </List.Item>
                                )}
                            /> */}
                            <Table bordered
                                key="tmtfulluser"
                                columns={columnsReviewTop}
                                dataSource={reviewLs}
                                pagination={false}
                            >
                            </Table>
                        </TabPane>)}
                    </Tabs>
                </Card>}
                <Card title={<>
                    <BlockOutlined /> {t('coreTechnologyCount')}
                    <Select
                        value={techType}
                        style={{ marginLeft: 20, marginRight: 20, width: 120 }}
                        onChange={handleChangeCoreTech}
                        options={[
                            { value: 'total', label: t('plannedTotal') },
                            { value: 'DEVELOPING', label: t('developing') },
                            { value: 'RELEASED', label: t('delivered') },
                            { value: 'PLANNING', label: t('planning') },
                        ]}
                    />
                    <RangePicker
                        style={{ width: 180 }}
                        picker="year"
                        format={dateFormat}
                        value={dateRange}
                        onChange={onChangeDate}
                    />
                </>}>
                    {/* <div ref={chartRef1} style={{ width: '100%', height: 300 }}></div> */}
                </Card>
                <Card title={<>
                    <BlockOutlined /> {t('last12MonthTechCount')}
                    <RangePicker
                        style={{ marginLeft: 20, width: 180 }}
                        picker="quarter"
                        format={dateFormat2}
                        value={completeTechListDateRange}
                        onChange={onChangeDateCompleteTechList}
                    />
                </>}>
                    {/* <div ref={chartRef2} style={{ width: '100%', height: 300 }}></div> */}
                </Card>
                <Card title={<>
                    <BlockOutlined /> {t('techMonthDevelopChart')}
                    <DatePicker style={{ marginLeft: 20, width: 100 }} value={dateTechDevelop} onChange={onChangeYearMonthDevelop} picker="year" />
                </>}>
                    <Tabs className='tabs_head_mb'
                        type="card"
                        defaultActiveKey={curTab3}
                        tabPosition="top"
                        onChange={onChangeTabs3}
                    >
                        {approvalType.map((_, i) => <TabPane tab={approvalType[i].label} key={approvalType[i].id} />)}
                    </Tabs>
                    {/* <div ref={chartRef3} style={{ width: '100%', height: 300 }}></div> */}
                </Card>
                <Card title={<>
                    <BlockOutlined /> {t('techPlanCostAnalysis')}
                </>}>
                    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                        {/* <div ref={chartRef4} style={{ width: '33%', height: 300 }}></div>
                        <div ref={chartRef5} style={{ width: '33%', height: 300 }}></div>
                        <div ref={chartRef6} style={{ width: '33%', height: 300 }}></div> */}
                    </div>
                </Card>
            </Space>}
        </div>
    )
}

export default BigScreen2
